export const CATALOG_FIELD_LIST = [
  { value: 'supplier_code', text: 'Código del proveedor' },
  { value: 'ean', text: 'EAN' },
  { value: 'description', text: 'Descripción', isRequired: true },
  { value: 'unit_price', text: 'Precio unitario', isRequired: true },
  { value: 'tax_percent', text: 'Porcentaje de impuesto' },
  { value: 'category', text: 'Categoría' },
  { value: 'units_per_case', text: 'Unidades por caja' },
  { value: 'package_weight', text: 'Peso' },
  { value: 'unit_measure', text: 'Unidad de medida' },
  { value: 'variation', text: 'Variación' },
]

export interface CatalogColumnSuggestion {
  headerRow: number;
  columnMap: { [field: string]: number };
}

export function validateCatalogColumnMap(columnMap: { [field: string]: number }, columnCount: number): boolean {
  const indexList = Object.values(columnMap).filter(index => index !== null && index !== undefined)
  return CATALOG_FIELD_LIST.filter(field => field.isRequired).every(field => Number.isInteger(columnMap[field.value]))
    && indexList.every(index => Number.isInteger(index) && index >= 0 && index < columnCount)
    && new Set(indexList).size === indexList.length
}
